export enum ArnUserRole {
  anybody = 'anybody',
  projectUser = 'projectUser',
  projectAdmin = 'projectAdmin',
  rootAdmin = 'rootAdmin',
}
